import React from "react";
import { CURRENCY } from "../../../contants";

const OrderSummary = ({ currentOrder, orderData, cgst, sgst }) => {
  return (
    <div className="p-3 border-top">
      <div className="d-flex justify-content-between align-items-center mb-1">
        <span className="text-muted small">Subtotal</span>
        <span className="font-weight-bold">
          {CURRENCY}
          {(orderData.subTotal || 0).toFixed(2)}
        </span>
      </div>
      {currentOrder?.discount > 0 && (
        <div className="d-flex justify-content-between align-items-center mb-1">
          <span className="text-muted small">Discount</span>
          <span className="font-weight-bold text-danger">
            -{CURRENCY}
            {(currentOrder.discount || 0).toFixed(2)}
          </span>
        </div>
      )}
      <div className="d-flex justify-content-between align-items-center mb-1">
        <span className="text-muted small">GST</span>
        <span className="font-weight-bold">
          {CURRENCY}
          {(
            (orderData.cgstCharges || 0) + (orderData.sgstCharges || 0)
          ).toFixed(2)}
        </span>
      </div>
      {currentOrder?.otherCharges > 0 && (
        <div className="d-flex justify-content-between align-items-center mb-1">
          <span className="text-muted small">Other Charges</span>
          <span className="font-weight-bold">
            {CURRENCY}
            {(currentOrder.otherCharges || 0).toFixed(2)}
          </span>
        </div>
      )}
    </div>
  );
};

export default OrderSummary;
